module.exports = __webpack_public_path__ + "static/media/desert-night.ea455fae.png";